export default "__VITE_ASSET__BWZ4Ldqx__"